module.exports = __webpack_public_path__ + "static/contri_onepercentM@2x-32e8d0cf980842813e93624488cdd903.png";